import { inject, injectable } from 'inversify';
import ProductsService from 'src/features/products/data/service/ProductsService';

import {
  GetProductsOnPromotionGroupedUseCaseInterface,
  GroupedPromotionalProductsUseCaseParams,
} from 'src/features/products/domain/useCases/types';
import { CategoryWithProducts, PaginatedResponse } from 'src/types/common';

@injectable()
class GroupedPromotionalProductsUseCase
  implements GetProductsOnPromotionGroupedUseCaseInterface
{
  @inject(ProductsService) private productsService!: ProductsService;

  async execute(params: GroupedPromotionalProductsUseCaseParams) {
    const response = await this.productsService.getProductsOnPromotion(params);

    return response.data as PaginatedResponse<CategoryWithProducts>;
  }
}

export default GroupedPromotionalProductsUseCase;
